import { render } from "./UsProduction.vue?vue&type=template&id=2cdb9e27&scoped=true"
import script from "./UsProduction.vue?vue&type=script&lang=js"
export * from "./UsProduction.vue?vue&type=script&lang=js"

import "./UsProduction.vue?vue&type=style&index=0&id=2cdb9e27&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cdb9e27"]])

export default __exports__